/* EXAMPLE

  let f = {'ts' : tdf.d('YYYY'), 'total' : tdf.n('0')}
  this.list = tdf.basicFormat(response.data, f)
*/



let tdf = {
  formatTableData: function(data){
    if (data instanceof Array !== true || data.length === 0){
      return data;
    }
    let keys = Object.keys(data[0])
    data.forEach(r =>{
      //t instanceof Date
      r.ts = moment(r.ts.split('Z')[0]).format("YYYY MMM Do YY"); 
    })
    return data;
  }, 
  
  basicFormat: function(data, customFormatters = {}){
    if (data instanceof Array !== true || data.length === 0){
      return data;
    }
    let formattedData = [];
    data.forEach(r=>formattedData.push({...r}));

    let keys = Object.keys(data[0]);
    formattedData.forEach(row =>{
      keys.forEach(key => {
        if(customFormatters[key] !== undefined){
          row[key] = customFormatters[key](row[key]);
          return;
        }
        if (typeof row[key] === "string" && row[key].length === 24 && isValidDate(new Date(row[key]))){
          row[key] = moment.utc(row[key]).format("YYYY-MM-DD h:mm:ss a");
          return;
        }
        if (row[key] instanceof Date){
          row[key] = moment.utc(row[key]).format("YYYY-MM-DD h:mm:ss a");
          return;
        }
        if (typeof row[key] === "number"){
          row[key] = row[key] === 0 ? '  -  ' : numeral(row[key]).format('0,0.00');
          return;
        }
  
      });
       
    });

    function isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    }

    return formattedData;
  },

  columnFormatter: function(columns, customTitles={}){
    function toTitleCase(str) {
      return str.replace(/_/g, ' ').replace(/\w\S*/g,txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()); 
    }

    columns = columns.map(t => customTitles[t] === undefined ? toTitleCase(t) : customTitles[t])
    return columns;
  },

  d: function(formatter){
    return function(v){
      return moment.utc(v).format(formatter);
    }
  },

  n: function(formatter){
    return function(v){
      return numeral(v).format(formatter);
    }
  },
  humanize: function(){
    return function(v){
      let now = moment(new Date).utc().subtract(6, 'hours')
      let then = moment.utc(v);
      return moment.duration(now.diff(then)).humanize()
    }
  }
}


export default tdf